import { findGroupMembers } from '@/api'

import type { GroupWithUserData } from './types'

export const recursivelyEnrichGroups = async (
  groupData: GroupWithUserData
): Promise<GroupWithUserData> => {
  if (groupData.gid) {
    try {
      const res = await findGroupMembers(groupData.gid, {
        page: undefined,
        size: 20,
        orderBy: undefined,
        reverse: undefined,
      })

      const groupWithUserData = {
        ...groupData,
        membersDetails: res.data ? res.data : [],
      } as unknown as GroupWithUserData

      if (groupData.children.length > 0) {
        const childPromises: Promise<GroupWithUserData>[] =
          groupData.children.map((childGroupData: GroupWithUserData) =>
            recursivelyEnrichGroups(childGroupData)
          )
        const childGroupsWithUserData: GroupWithUserData[] = await Promise.all(
          childPromises
        )
        groupWithUserData.children = childGroupsWithUserData
      } else {
        groupWithUserData.children = []
      }

      return groupWithUserData
    } catch (error: any) {
      if (error?.response?.status === 401) {
        // eslint-disable-line
        return {
          ...groupData,
          membersDetails: [],
          children: [],
        }
      } else {
        throw error
      }
    }
  } else {
    return {
      ...groupData,
      membersDetails: [],
      children: [],
    }
  }
}
